// bao migrate skip
import "./bao-number-box";
import timerTemplate from "./bao-timer.html";
import * as ko from "knockout";
import * as $ from "jquery";
export class TimerViewModel {
    private _subs: KnockoutSubscription[] = [];
    HtmlElement: any;
    constructor(element, private valueAccessor: () => baoTimerConfig) {
        this.HtmlElement = element;
        //Initialize pureComputed Variables
        this.TimerHourValue = ko.observable(0);
        this.TimerHour = ko.pureComputed({
            read: () => {
                return this.TimerHourValue();
            }, write: (newValue) => {
                if (newValue < 0 || newValue === null || typeof newValue === "undefined") {
                }
                else {
                    this.TimerHourValue(newValue);
                }
            }
        });
        this.TimerMinuteValue = ko.observable(0);
        this.TimerMinute = ko.pureComputed({
            read: () => {
                return this.TimerMinuteValue();
            }, write: (newValue) => {
                if (newValue < 0 || newValue === null || typeof newValue === "undefined") {
                }
                else {
                    ////Minutes maximum is 59
                    //while (newValue >= 60) {
                    //    newValue -= 60;
                    //    //Overflow --> Hour++
                    //    this.TimerHour(this.TimerHour() + 1);
                    //}
                    this.TimerMinuteValue(newValue);
                }
            }
        });
        this.TimerSecondValue = ko.observable(0);
        this.TimerSecond = ko.pureComputed({
            read: () => {
                return this.TimerSecondValue();
            }, write: (newValue) => {
                if (newValue < 0 || newValue === null || typeof newValue === "undefined") {
                }
                else {
                    ////Seconds maximum is 59
                    //while (newValue >= 60) {
                    //    newValue -= 60;
                    //    this.TimerMinute(this.TimerMinute() + 1);
                    //}
                    this.TimerSecondValue(newValue);
                }
            }
        });
        this._subs.push(this.TimerHourValue.subscribe(() => {
            this.UpdateValue();
        }));
        this._subs.push(this.TimerMinuteValue.subscribe(() => {
            this.UpdateValue();
        }));
        this._subs.push(this.TimerSecondValue.subscribe(() => {
            this.UpdateValue();
        }));
    }
    InitializeBaoTimer() {
        //this.HtmlElement.innerHTML = timerTemplate; //alternative
        $(this.HtmlElement).html(timerTemplate);
        ko.applyBindingsToDescendants(this, this.HtmlElement);
    }
    dispose() {
        for (let i = 0; i > this._subs.length; i++) {
            this._subs[i].dispose();
        }
        this.TimerHour.dispose();
        this.TimerMinute.dispose();
        this.TimerSecond.dispose();
    }
    UpdateValue() {
        let obs = this.valueAccessor().value;
        obs(this.TimerHourValue() * 3600 + this.TimerMinuteValue() * 60 + this.TimerSecondValue());
        this.valueAccessor().hour(this.TimerHourValue());
        this.valueAccessor().minute(this.TimerMinuteValue());
        this.valueAccessor().second(this.TimerSecondValue());
    }
    TimerHourValue: KnockoutObservable<number>;
    TimerMinuteValue: KnockoutObservable<number>;
    TimerSecondValue: KnockoutObservable<number>;
    TimerHour: KnockoutComputed<number>;
    TimerMinute: KnockoutComputed<number>;
    TimerSecond: KnockoutComputed<number>;
    TimerHourClickUp() {
        this.TimerHour(this.TimerHour() + 1);
    }
    TimerHourClickDown() {
        this.TimerHour(this.TimerHour() - 1);
    }
    TimerMinuteClickUp() {
        this.TimerMinute(this.TimerMinute() + 1);
    }
    TimerMinuteClickDown() {
        this.TimerMinute(this.TimerMinute() - 1);
    }
    TimerSecondClickUp() {
        this.TimerSecond(this.TimerSecond() + 1);
    }
    TimerSecondClickDown() {
        this.TimerSecond(this.TimerSecond() - 1);
    }
}
var baoTimer: KnockoutBindingHandler = {
    init: function (element, valueAccessor: () => baoTimerConfig, allBindingsAccessor, viewModel, bindingContext) {
        var timerViewModel = new TimerViewModel(element, valueAccessor);
        timerViewModel.InitializeBaoTimer();
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            timerViewModel.dispose();
        });
        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor, allBindings, viewModel) {
    }
};
ko.bindingHandlers["baoTimer"] = baoTimer;
export interface baoTimerConfig {
    value: KnockoutObservable<number>;
    hour: KnockoutObservable<number>;
    minute: KnockoutObservable<number>;
    second: KnockoutObservable<number>;
}